import { Flex } from '@lce/slice';
import * as React from 'react';
import { useState } from 'react';
import * as Styled from './DealTile.style';
import { DealTile as IDealTileProps } from '../../../lib/deals';

export const DealTile: React.FC<IDealTileProps> = ({
  title,
  image,
  dealNameLg,
  dealNameSm,
  instructions,
  promo,
  offerEnds,
  legal,
  readMore,
  dealUrl,
  buttonText
}) => {
  const [showLegal, setShowLegal] = useState<boolean>(false);

  const handleClick = () => {
    setShowLegal(!showLegal);
  };

  return (
    <Styled.DealTile data-testid="deal__tile">
      <Styled.TopBorder>
        <Styled.TopBorderWrapper />
        <Styled.DealCategory>
          <Styled.DealCategoryName data-testid="dealTile__deal-category-name">{title}</Styled.DealCategoryName>
        </Styled.DealCategory>
        <Styled.TopBorderWrapper />
      </Styled.TopBorder>
      <Flex>
        <Styled.SideBorder isLeft={true} />
        <Flex flexDirection="column" width="100%" padding={['20px 12px 6px', '20px 12px 6px', '20px 12px 12px']}>
          {image && (
            <Styled.ImageWrapper>
              <Styled.CouponCodeProductImage data-testid="dealTile__deal-img" src={image.url} alt={image.alt} />
            </Styled.ImageWrapper>
          )}
          <Styled.BodyWrapper>
            <Styled.DealTitle data-testid="dealTile__deal-title">{dealNameLg}</Styled.DealTitle>
            <Styled.DealSubTitle data-testid="dealTile__deal-subTitle">{dealNameSm}</Styled.DealSubTitle>
            <Styled.DealInfoWrapper>
              <Styled.DealInfo data-testid="dealTile__deal-info">{instructions}</Styled.DealInfo>
              <Styled.CodeWrapper>
                <Styled.DealCode data-testid="dealTile__deal-code">{promo}</Styled.DealCode>
                <Styled.Line />
                <Styled.ApplyCode as="a" href={dealUrl} id={`click-deals-${promo}`} data-testid="apply-code-button">{buttonText}</Styled.ApplyCode>
              </Styled.CodeWrapper>
            </Styled.DealInfoWrapper>
          </Styled.BodyWrapper>
          <Styled.FooterWrapper showLegal={showLegal}>
            <Styled.DealFooter>
              <Styled.OfferExpiration data-testid="dealTile__deal-EndDate">{offerEnds}</Styled.OfferExpiration>
              <Styled.ReadMoreSection
                aria-labelledby={readMore}
                as="button"
                onClick={handleClick}
                data-testid="dealTile__deal-readMore-button"
              >
                <Styled.ReadMore>{readMore}</Styled.ReadMore>
                {!showLegal ? <Styled.DownArrow /> : <Styled.UpArrow />}
              </Styled.ReadMoreSection>
            </Styled.DealFooter>
            {showLegal && (
              <Styled.LegalWrapper>
                <Styled.Disclaimer data-testid="dealTile__deal-legalInfo">{legal}</Styled.Disclaimer>
              </Styled.LegalWrapper>
            )}
          </Styled.FooterWrapper>
        </Flex>
        <Styled.SideBorder isLeft={false} />
      </Flex>
      <Styled.BottomBorder />
    </Styled.DealTile>
  );
};
